import { bucket } from '../firebase/config';
import buildUploadPath from '../helpers/uploads/buildUploadPath';

/**
 * Uploadt het gekozen bestand en geeft de download-URL terug via `setFile`.
 *
 * Zonder `folder` blijft het bestand in de hoofdmap staan onder zijn eigen naam
 * — dat is het oude gedrag, waar `embedPortfolioDocument` op vertrouwt. Geef een
 * map mee voor uploads die van buiten een account komen: die krijgen dan een
 * uuid in het pad, zodat twee gelijknamige bestanden elkaar niet overschrijven.
 * AI-CONTEXT: See docs/inbox.md #122
 *
 * @param {{target: {files: FileList | File[]}}} e - Change-event van het bestandsveld
 * @param {(url: string) => void} setFile - Krijgt de download-URL
 * @param {(file: File) => void} [setFileMeta] - Krijgt het bestand zelf
 * @param {(progress: number) => void} [setLoading] - Krijgt het uploadpercentage
 * @param {(err: Error) => void} [onError] - Krijgt een mislukte upload
 * @param {string} [folder] - Map in de opslag; leeg = hoofdmap
 */
const saveFile = (e, setFile, setFileMeta, setLoading, onError, folder) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileMeta && setFileMeta(file);
    setLoading && setLoading(0);

    const storageRef = bucket.ref(buildUploadPath(file.name, folder));
    const uploadTask = storageRef.put(file);

    uploadTask.on(
        'state_changed',
        snapshot => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setLoading && setLoading(progress);
        },
        err => {
            console.error('Upload failed:', err);
            setLoading && setLoading(0);
            if (onError) {
                onError(err);
            }
        },
        () => {
            // Zonder vangnet hier klapt een mislukte link-ophaal er stil uit:
            // de balk blijft dan op 'Upload voltooid' staan terwijl er nooit
            // een bestand wordt opgeslagen.
            uploadTask.snapshot.ref.getDownloadURL()
                .then(downloadURL => {
                    setFile(downloadURL);
                })
                .catch(err => {
                    console.error('Could not read download URL:', err);
                    setLoading && setLoading(0);
                    if (onError) {
                        onError(err);
                    }
                });
        }
    );
}

export default saveFile;
